import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { SyncService } from '../../../services/sync.service';
import { AuthService } from '../../../services/auth.service';
// Note: the guard now shares the same singleton SyncService that performs the
// runtime sync (AppComponent / DataSyncComponent). Previously it read
// `isAppLocked` from a separate legacy SyncService instance that nothing ever
// locked, so the check was effectively dead. See issue #3.

@Injectable({
    providedIn: 'root'
})
export class ValidateSyncGuard  {
    private authService = inject(AuthService);
    private syncService = inject(SyncService);

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.syncService.isAppLocked()) {
            this.authService.logout();
            return false;
        }

        return true;
    }
}
